/* eslint-disable no-unused-vars */
import { PPI } from "@/box/constants.js"

function getSvgForGeom(box) {
  const svgWidth = box.getDocumentWidth();
  const svgHeight = box.getDocumentHeight();

  let svg = `
          <svg
          xmlns="http://www.w3.org/2000/svg"
          width="${svgWidth}"
          height="${svgHeight}"
          viewBox="0 0 ${svgWidth} ${svgHeight}"
          stroke="blue"
          stroke-width="0.01" >
          `;

  box.panels.forEach((panel) => {
    svg += `<path fill="none" data-panelName="${panel.name} ${panel.row}Row" data-panelWidth="${panel.width}" data-panelHeight="${panel.height}" d="${panel.path}"/>`;
  })

  svg += "</svg>";

  return svg;
}

function get2DEditorSvg(box, printSide = "outside") {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  const largerDocumentDimension = documentWidth > documentHeight ? documentWidth : documentHeight
  const strokeWidth = largerDocumentDimension / 3000

  let svg = `
    <svg
      width="${documentWidth}"
      height="${documentHeight}"
      viewBox="0 0 ${documentWidth} ${documentHeight}"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1" stroke-width="${strokeWidth}">
  `

  svg += getOutline(box, printSide)

  svg += getCutlines(box, printSide)

  svg += `</svg>`;
  return svg
}

function createPathDefinitionForOutlineWithBleed(box, isNormalized = false, printSide = "outside") {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  // Normalizes x between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedX(x) {
    return isNormalized ? x / documentWidth: x;
  }

  // Normalizes y between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedY(y) {
    return isNormalized ? y / documentHeight : y;
  }

  const B = box.bleedInPx
  const MT = box.materialThicknessInPx
  const D = box.depthInPx
  const OW = box.overlapWidthInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const topRightDustFlap = panels.find(panel => panel.name === "outsideFrontDustFlapRight")
  const topLeftDustFlap = panels.find(panel => panel.name === "outsideFrontDustFlapLeft")
  const insideRightWall = panels.find(panel => panel.name === "insideRightWall")
  const outsideBackWallDustFlapRight = panels.find(panel => panel.name === "outsideBackWallDustFlapRight")
  const outsideBackWallDustFlapLeft = panels.find(panel => panel.name === "outsideBackWallDustFlapLeft")
  const topSide = panels.find(panel => panel.name === "topSide")
  const frontFlapOutside = panels.find(panel => panel.name === "frontFlapOutside")
  const outsideRightWall = panels.find(panel => panel.name === "outsideRightWall")
  const outsideLeftWall = panels.find(panel => panel.name === "outsideLeftWall")

  const d = `
      M ${adjustedX(documentWidth / 2)} ${adjustedY(0)}
      L ${adjustedX((topRightDustFlap.left + topRightDustFlap.width) + B)} ${adjustedY(0)}
      v ${adjustedY(topRightDustFlap.height)}
      H ${adjustedX(outsideRightWall.left + outsideRightWall.width)}
      l ${adjustedX(OW)} ${adjustedY(2*MT)}
      h ${adjustedX(insideRightWall.width + B)}
      v ${adjustedY(insideRightWall.height + 2*B)}
      h ${adjustedX(-insideRightWall.width - B)}
      l ${adjustedX(-OW)} ${adjustedY(2*MT)}
      L ${adjustedX(outsideBackWallDustFlapRight.left + outsideBackWallDustFlapRight.width + B)} ${adjustedY(outsideBackWallDustFlapRight.top + B)}
      v ${adjustedY(outsideBackWallDustFlapRight.height)}
      H ${adjustedX(topSide.left + topSide.width + B)}
      V ${adjustedY(frontFlapOutside.top + B)}
      H ${adjustedX(frontFlapOutside.left + frontFlapOutside.width + B)}
      V ${adjustedY(frontFlapOutside.top + frontFlapOutside.height + B)}
      h ${adjustedX(-(frontFlapOutside.width + 2*B))}
      v ${adjustedY(-(frontFlapOutside.height))}
      H ${adjustedX(frontFlapOutside.left - OW - B)}
      v ${
        // don't know why the MT was needed @TODO: Check
        adjustedY(-(topSide.height + 1*MT))
      }
      H ${adjustedX(outsideBackWallDustFlapLeft.left - B)}
      v ${adjustedY(-(outsideBackWallDustFlapLeft.height))}
      L ${adjustedX(outsideLeftWall.left)} ${adjustedY(outsideBackWallDustFlapRight.top + B)}
      l ${adjustedX(-OW)} ${adjustedY(-2* MT)}
      h ${adjustedX(-insideRightWall.width - B)}
      v ${adjustedY(-insideRightWall.height - 2*B)}
      h ${adjustedX(insideRightWall.width + B)}
      l ${adjustedX(OW)} ${adjustedY(-2*MT)}
      L ${adjustedX(topLeftDustFlap.left - B)} ${adjustedY(topLeftDustFlap.top + topLeftDustFlap.height - B)}
      v ${adjustedY(-topLeftDustFlap.height)}
      L ${adjustedX(documentWidth / 2)} ${adjustedY(0)}
      Z
    `
  return d
  // return printSide === 'outside' ? d : flipPathVertically(d)
}

function getOutlineWithBleed(box, isNormalized = false, printSide = "outside") {
  const transformElement = printSide === 'inside' ? `transform: scaleX(-1) translateX(-1px);` : ''
  // const transformElement = printSide === 'inside' ? `` : ''
  const path = `
    <path
      style="${transformElement}"
      stroke="green"
      fill="#000000"
      d="${createPathDefinitionForOutlineWithBleed(box, isNormalized, printSide)}"
    />
  `
  return path
}

function createPathDefinitionForOutlineWithoutNonPrintPanels(box, isNormalized = false) {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  // Normalizes x between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedX(x) {
    return isNormalized ? x / documentWidth: x;
  }

  // Normalizes y between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedY(y) {
    return isNormalized ? y / documentHeight : y;
  }

  const B = box.bleedInPx
  const MT = box.materialThicknessInPx
  const OW = box.overlapWidthInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const topRightDustFlap = panels.find(panel => panel.name === "outsideFrontDustFlapRight")
  const topLeftDustFlap = panels.find(panel => panel.name === "outsideFrontDustFlapLeft")
  const insideRightWall = panels.find(panel => panel.name === "insideRightWall")
  const outsideBackWallDustFlapRight = panels.find(panel => panel.name === "outsideBackWallDustFlapRight")
  const outsideBackWallDustFlapLeft = panels.find(panel => panel.name === "outsideBackWallDustFlapLeft")
  const topSide = panels.find(panel => panel.name === "topSide")
  const frontFlapOutside = panels.find(panel => panel.name === "frontFlapOutside")
  const outsideFrontWall = panels.find(panel => panel.name === "outsideFrontWall")
  const outsideRightWall = panels.find(panel => panel.name === "outsideRightWall")
  const outsideLeftWall = panels.find(panel => panel.name === "outsideLeftWall")
  const outsideBackWall = panels.find(panel => panel.name === "outsideBackWall")

  const d = `
    M ${adjustedX(documentWidth / 2)} ${adjustedY(0)}
    L ${adjustedX(outsideFrontWall.left + outsideFrontWall.width + B)} ${adjustedY(0)}
    v ${adjustedY(topRightDustFlap.height)}
    H ${adjustedX(outsideRightWall.left + outsideRightWall.width)}
    l ${adjustedX(OW)} ${adjustedY(2*MT)}
    h ${adjustedX(insideRightWall.width + B)}
    v ${adjustedY(insideRightWall.height + 2*B)}
    h ${adjustedX(-insideRightWall.width - B)}
    l ${adjustedX(-OW)} ${adjustedY(2*MT)}
    L ${adjustedX(outsideBackWallDustFlapRight.left + B)} ${adjustedY(outsideBackWallDustFlapRight.top + B)}
    V ${adjustedY(outsideBackWall.top + outsideBackWall.height - B)}
    H ${adjustedX(topSide.left + topSide.width + B)}
    V ${adjustedY(topSide.top + topSide.height + B)}
    H ${adjustedX(frontFlapOutside.left + frontFlapOutside.width + B)}
    V ${adjustedY(frontFlapOutside.top + frontFlapOutside.height + B)}
    h ${adjustedX(-(frontFlapOutside.width + 2*B))}
    V ${adjustedY(topSide.top + topSide.height + B)}
    H ${adjustedX(topSide.left - B)}
    V ${adjustedY(topSide.top - B)}
    H ${adjustedX(outsideBackWallDustFlapLeft.left + outsideBackWallDustFlapLeft.width - B)}
    V ${adjustedY(outsideBackWallDustFlapLeft.top + B)}
    L ${adjustedX(outsideLeftWall.left)} ${adjustedY(outsideBackWallDustFlapRight.top + B)}
    l ${adjustedX(-OW)} ${adjustedY(-2* MT)}
    h ${adjustedX(-insideRightWall.width - B)}
    v ${adjustedY(-insideRightWall.height - 2*B)}
    h ${adjustedX(insideRightWall.width + B)}
    l ${adjustedX(OW)} ${adjustedY(-2*MT)}
    L ${adjustedX(topLeftDustFlap.left + topLeftDustFlap.width - B)} ${adjustedY(topLeftDustFlap.top + topLeftDustFlap.height - B)}
    v ${adjustedY(-topLeftDustFlap.height)}
    L ${adjustedX(documentWidth / 2)} ${adjustedY(0)}
    Z
  `
  return d
}

function createPathDefinitionForOutlineWithoutNonPrintPanelsForInsidePrint(box, isNormalized = false) {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  // Normalizes x between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedX(x) {
    return isNormalized ? x / documentWidth: x;
  }

  // Normalizes y between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedY(y) {
    return isNormalized ? y / documentHeight : y;
  }

  const B = box.bleedInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const topRightDustFlap = panels.find(panel => panel.name === "outsideFrontDustFlapRight")
  const topLeftDustFlap = panels.find(panel => panel.name === "outsideFrontDustFlapLeft")
  const outsideBackWallDustFlapLeft = panels.find(panel => panel.name === "outsideBackWallDustFlapLeft")
  const topSide = panels.find(panel => panel.name === "topSide")
  const frontFlapOutside = panels.find(panel => panel.name === "frontFlapOutside")
  const outsideFrontWall = panels.find(panel => panel.name === "outsideFrontWall")
  const outsideBackWall = panels.find(panel => panel.name === "outsideBackWall")

  const outsideBottom = panels.find(panel => panel.name === "outsideBottom")

  const d = `
    M ${adjustedX(documentWidth / 2)} ${adjustedY(0)}
    L ${adjustedX(outsideFrontWall.left + outsideFrontWall.width + B)} ${adjustedY(0)}
    v ${adjustedY(topRightDustFlap.height)}
    H ${adjustedX(outsideBottom.left + outsideBottom.width + B)}
    L ${adjustedX(outsideBottom.left + outsideBottom.width + B)} ${adjustedY(outsideBottom.top + outsideBottom.height + B)}
    H ${adjustedX(outsideBackWall.left + outsideBackWall.width + B)}
    V ${adjustedY(outsideBackWall.top + outsideBackWall.height - B)}
    H ${adjustedX(topSide.left + topSide.width + B)}
    V ${adjustedY(topSide.top + topSide.height + B)}
    H ${adjustedX(frontFlapOutside.left + frontFlapOutside.width + B)}
    V ${adjustedY(frontFlapOutside.top + frontFlapOutside.height + B)}
    h ${adjustedX(-(frontFlapOutside.width + 2*B))}
    V ${adjustedY(topSide.top + topSide.height + B)}
    H ${adjustedX(topSide.left - B)}
    V ${adjustedY(topSide.top - B)}
    H ${adjustedX(outsideBackWallDustFlapLeft.left + outsideBackWallDustFlapLeft.width - B)}
    V ${adjustedY(outsideBackWallDustFlapLeft.top + B)}
    H ${adjustedX(outsideBottom.left - B)}
    L ${adjustedX(outsideBottom.left - B)} ${adjustedY(topLeftDustFlap.top + topLeftDustFlap.height - B)}
    H ${adjustedX(outsideFrontWall.left - B)}
    v ${adjustedY(-topLeftDustFlap.height)}
    L ${adjustedX(documentWidth / 2)} ${adjustedY(0)}
    Z
  `
  return d
}

function getOutlineWithoutNonPrintPanels(box, isNormalized = false, printSide = 'outside') {
  const def = printSide === 'outside'
    ? createPathDefinitionForOutlineWithoutNonPrintPanels(box, isNormalized)
    : createPathDefinitionForOutlineWithoutNonPrintPanelsForInsidePrint(box, isNormalized)

  const transformStyle = printSide === 'outside' ? '' : `transform: scaleX(-1); transform-origin: center;`

  const path = `
    <path
      style="${transformStyle}"
      stroke="green"
      fill="#000000"
      d="${def}" />
  `
  return path
}

function createOutlinePathDefinition(box) {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  const B = box.bleedInPx
  const MT = box.materialThicknessInPx
  const W = box.widthInPx
  const L = box.lengthInPx
  const D = box.depthInPx
  const OW = box.overlapWidthInPx
  const FW = box.flapWidthInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const topRightDustFlap = panels.find(panel => panel.name === "outsideFrontDustFlapRight")
  const topLeftDustFlap = panels.find(panel => panel.name === "outsideFrontDustFlapLeft")
  const insideRightWall = panels.find(panel => panel.name === "insideRightWall")
  const outsideBackWallDustFlapRight = panels.find(panel => panel.name === "outsideBackWallDustFlapRight")
  const topSide = panels.find(panel => panel.name === "topSide")
  const frontFlapOutside = panels.find(panel => panel.name === "frontFlapOutside")
  const outsideBackWallDustFlapLeft = panels.find(panel => panel.name === "outsideBackWallDustFlapLeft")
  const outsideRightWall = panels.find(panel => panel.name === "outsideRightWall")
  const outsideLeftWall = panels.find(panel => panel.name === "outsideLeftWall")

  const d = `
    M ${documentWidth / 2} ${B}
    L ${(topRightDustFlap.left + topRightDustFlap.width)} ${B}
    v ${topRightDustFlap.height}
    H ${outsideRightWall.left + outsideRightWall.width}
    l ${OW} ${2*MT}
    h ${insideRightWall.width}
    v ${insideRightWall.height}
    h ${-insideRightWall.width}
    l ${-OW} ${2*MT}
    L ${outsideBackWallDustFlapRight.left + outsideBackWallDustFlapRight.width} ${outsideBackWallDustFlapRight.top}
    v ${outsideBackWallDustFlapRight.height}
    h ${-outsideBackWallDustFlapRight.width}

    l ${-4*MT} ${MT}

    H ${topSide.left + topSide.width + 2*MT - B}
    V ${frontFlapOutside.top}
    H ${frontFlapOutside.left + frontFlapOutside.width}
    V ${frontFlapOutside.top + frontFlapOutside.height}
    h ${-(frontFlapOutside.width)}
    v ${-(frontFlapOutside.height)}
    H ${topSide.left}
    v ${-(topSide.height)}

    l ${
      // don't know why 6*MT is needed @TODO: check
      6*MT
    } ${0}
    L ${outsideBackWallDustFlapLeft.left + outsideBackWallDustFlapLeft.width} ${outsideBackWallDustFlapLeft.top + outsideBackWallDustFlapLeft.height}

    H ${outsideBackWallDustFlapLeft.left}
    v ${-(outsideBackWallDustFlapLeft.height)}

    L ${outsideLeftWall.left} ${outsideBackWallDustFlapRight.top}
    l ${-OW} ${-2* MT}
    h ${-insideRightWall.width}
    v ${-insideRightWall.height}
    h ${insideRightWall.width}
    l ${OW} ${-2*MT}
    L ${topLeftDustFlap.left} ${topLeftDustFlap.top + topLeftDustFlap.height}
    v ${-topLeftDustFlap.height}
    L ${documentWidth / 2} ${B}
    Z
  `

  return d
}

function getOutline(box, printSide = "outside") {
  const transformElement = printSide === 'inside'
    ? `transform: scaleX(-1); transform-origin: center;`
    : ''
  const path = `
      <path
        style="${transformElement}"
        stroke="blue"
        fill="none"
        d="${createOutlinePathDefinition(box)}" />
  `

  return path
}

function createCutlinesPathDefinition(box) {
  const MT = box.materialThicknessInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const outsideFrontWall = panels.find(panel => panel.name === "outsideFrontWall")
  const outsideBackWall = panels.find(panel => panel.name === "outsideBackWall")
  const topSide = panels.find(panel => panel.name === "topSide")
  const leftOverlap = panels.find(panel => panel.name === "leftOverlap")
  const rightOverlap = panels.find(panel => panel.name === "rightOverlap")
  const outsideBottom = panels.find(panel => panel.name === "outsideBottom")
  const frontFlapOutside = panels.find(panel => panel.name === "frontFlapOutside")

  const outsideFrontDustFlapLeft = panels.find(panel => panel.name === "outsideFrontDustFlapLeft")
  const outsideFrontDustFlapRight = panels.find(panel => panel.name === "outsideFrontDustFlapRight")
  const outsideBackWallDustFlapLeft = panels.find(panel => panel.name === "outsideBackWallDustFlapLeft")
  const outsideBackWallDustFlapRight = panels.find(panel => panel.name === "outsideBackWallDustFlapRight")

  // Red part of foldlines
  const redArea = `
    M ${outsideFrontWall.left} ${outsideFrontWall.top + outsideFrontWall.height}
    h ${outsideFrontWall.width}
    M ${outsideBackWall.left} ${outsideBackWall.top}
    h ${outsideBackWall.width}
    M ${outsideBackWall.left + 4*MT} ${outsideBackWall.top + outsideBackWall.height}
    h ${outsideBackWall.width - 8*MT}
    M ${topSide.left} ${topSide.top + topSide.height}
    h ${topSide.width}
    M ${outsideFrontDustFlapLeft.left + outsideFrontDustFlapLeft.width} ${outsideFrontDustFlapLeft.top}
    v ${outsideFrontDustFlapLeft.height}
    M ${outsideFrontDustFlapRight.left} ${outsideFrontDustFlapRight.top}
    v ${outsideFrontDustFlapRight.height}
    M ${leftOverlap.left} ${leftOverlap.top + 2*MT}
    v ${leftOverlap.height - 4*MT}
    M ${leftOverlap.left + leftOverlap.width} ${leftOverlap.top}
    v ${leftOverlap.height}
    M ${outsideBottom.left} ${outsideBottom.top}
    v ${outsideBottom.height}
    M ${outsideBottom.left + outsideBottom.width} ${outsideBottom.top}
    v ${outsideBottom.height}
    M ${rightOverlap.left} ${rightOverlap.top}
    v ${rightOverlap.height}
    M ${rightOverlap.left + rightOverlap.width} ${rightOverlap.top + 2*MT}
    v ${rightOverlap.height - 4*MT}
    M ${outsideBackWallDustFlapLeft.left + outsideBackWallDustFlapLeft.width} ${outsideBackWallDustFlapLeft.top}
    v ${outsideBackWallDustFlapLeft.height}
    M ${outsideBackWallDustFlapRight.left} ${outsideBackWallDustFlapRight.top}
    v ${outsideBackWallDustFlapRight.height}
  `
  // White part of foldlines
  const whiteFoldLines = `
    M ${outsideFrontWall.left} ${outsideFrontWall.top + outsideFrontWall.height}
    h ${outsideFrontWall.width}
    M ${outsideBackWall.left} ${outsideBackWall.top}
    h ${outsideBackWall.width}
    M ${outsideBackWall.left + 4*MT} ${outsideBackWall.top + outsideBackWall.height}
    h ${outsideBackWall.width - 8*MT}
    M ${topSide.left} ${topSide.top + topSide.height}
    h ${topSide.width}
    M ${outsideFrontDustFlapLeft.left + outsideFrontDustFlapLeft.width} ${outsideFrontDustFlapLeft.top}
    v ${outsideFrontDustFlapLeft.height}
    M ${outsideFrontDustFlapRight.left} ${outsideFrontDustFlapRight.top}
    v ${outsideFrontDustFlapRight.height}
    M ${leftOverlap.left} ${leftOverlap.top + 2*MT}
    v ${leftOverlap.height - 4*MT}
    M ${leftOverlap.left + leftOverlap.width} ${leftOverlap.top}
    v ${leftOverlap.height}
    M ${outsideBottom.left} ${outsideBottom.top}
    v ${outsideBottom.height}
    M ${outsideBottom.left + outsideBottom.width} ${outsideBottom.top}
    v ${outsideBottom.height}
    M ${rightOverlap.left} ${rightOverlap.top}
    v ${rightOverlap.height}
    M ${rightOverlap.left + rightOverlap.width} ${rightOverlap.top + 2*MT}
    v ${rightOverlap.height - 4*MT}
    M ${outsideBackWallDustFlapLeft.left + outsideBackWallDustFlapLeft.width} ${outsideBackWallDustFlapLeft.top}
    v ${outsideBackWallDustFlapLeft.height}
    M ${outsideBackWallDustFlapRight.left} ${outsideBackWallDustFlapRight.top}
    v ${outsideBackWallDustFlapRight.height}
  `

  const blueLines = `
    M ${outsideFrontDustFlapLeft.left} ${outsideFrontDustFlapLeft.top + outsideFrontDustFlapLeft.height}
    h ${outsideFrontDustFlapLeft.width - 4*MT}
    l ${4*MT} ${MT}
    M ${outsideFrontDustFlapRight.left + outsideFrontDustFlapRight.width} ${outsideFrontDustFlapRight.top + outsideFrontDustFlapRight.height}
    h ${-outsideFrontDustFlapRight.width +  4*MT}
    l ${-4*MT} ${MT}
    M ${outsideBackWallDustFlapLeft.left} ${outsideBackWallDustFlapLeft.top}
    h ${outsideBackWallDustFlapLeft.width - 2*MT}
    l ${2*MT} ${-MT}
    M ${outsideBackWallDustFlapRight.left + outsideBackWallDustFlapRight.width} ${outsideBackWallDustFlapRight.top}
    h ${-outsideBackWallDustFlapRight.width +  2*MT}
    l ${-2*MT} ${-MT}
  `
  return {
    redArea,
    whiteFoldLines,
    blueLines
  }
}

function getCutlines(box, printSide = "outside") {
  const {
    redArea,
    whiteFoldLines,
    blueLines
  } = createCutlinesPathDefinition(box)

  const transformElement = printSide === 'inside'
    ? `transform: scaleX(-1); transform-origin: center;`
    : ''

  // Red part of foldlines
  let path = `
    <path
      style="${transformElement}"
      stroke="red"
      fill="none"
      stroke-dasharray="10 10"
      d="${redArea}" />
  `

  // White part of foldlines
  path += `
    <path
      style="${transformElement}"
      stroke="white"
      fill="none"
      stroke-dasharray="10 10"
      stroke-dashoffset="10"
      d="${whiteFoldLines}" />
  `

  path += `
    <path
      style="${transformElement}"
      stroke="blue"
      fill="none"
      d="${blueLines}" />
  `


  return path

}

export {
  getSvgForGeom,
  get2DEditorSvg,
  getOutlineWithBleed,
  getOutlineWithoutNonPrintPanels,
  getOutline,
  getCutlines,
}
